var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import withBranding from "@irati/brand/withBranding";
import { brand } from "@irati/ui/src/global/colors";
import { getBannerImage } from "@irati/utils/images/getImageSize/getImageSize";
import { determineDealColor } from "@irati/deals/helpers/deals/appearance";
import tracking from "@irati-tracking/perks/perks";
import DEAL_PAGES from "../../constants/dealPage";
import FullWidthBanner from "../ui/FullWidthBanner/FullWidthBanner";
import StyledContainer from "./styled/ContainerDiv";
import StyledBsContainer from "./styled/BsContainer";
import StyledFavouriteButton from "./styled/FavouriteButton";
var LayoutDealsInfo = /** @class */ (function (_super) {
    __extends(LayoutDealsInfo, _super);
    function LayoutDealsInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFavChange = function (isFavourite) {
            return isFavourite ? tracking.favouritePerk(_this.props.deal, DEAL_PAGES.PERK) : tracking.unfavouritePerk(_this.props.deal, DEAL_PAGES.PERK);
        };
        return _this;
    }
    Object.defineProperty(LayoutDealsInfo.prototype, "brandColor", {
        get: function () {
            var businessLogoUrl = this.props.branding.businessLogoUrl;
            return determineDealColor(this.props.deal, businessLogoUrl, brand.default);
        },
        enumerable: false,
        configurable: true
    });
    LayoutDealsInfo.prototype.render = function () {
        var _a = this.props, children = _a.children, deal = _a.deal;
        return (React.createElement(StyledContainer, null,
            React.createElement(FullWidthBanner, { src: getBannerImage(deal.bannerImage), color: this.brandColor, useImgTag: !!deal.bannerImage }),
            React.createElement(StyledBsContainer, { className: "container" },
                React.createElement(StyledFavouriteButton, { deal: deal, onChange: this.handleFavChange })),
            children));
    };
    return LayoutDealsInfo;
}(Component));
export default withBranding(LayoutDealsInfo);
